<template>
  <v-container
    id="data-tables"
    tag="section"
    fluid
  >
    <base-material-card
      color="primary"
      icon="mdi-file-multiple-outline"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Validações de SDI
        </div>
      </template>
      <v-btn
        id="btn-nova-valid-sdi"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float:left"
        relative
        text
        medium
        @click="$router.push(`add`);"
      >
        <v-icon
          left
          size="30px"
        >
          mdi-plus-circle
        </v-icon>
        NOVA VALIDAÇÃO DE SDI
      </v-btn>
      <v-text-field
        id="valid-sdi-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 265px"
      />
      <general-progress-bars
        class="mt-11"
        :items="downloadProgressData"
        prefix-text="Baixando Validação de SDI"
      />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading"
        :mobile-breakpoint="800"
        no-data-text="Nenhuma Validação de SDI disponível"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="text-truncate-column"
                v-bind="attrs"
                v-on="on"
              >
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario.nome }}
        </template>
        <template v-slot:[`item.data_processamento`]="{ item }">
          {{ item.data_processamento | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-valid-sdi"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="(downloadProgressData[item.id] !== undefined) ? true : false"
            @click="downloadItem(item)"
          >
            <v-icon small>
              mdi-download
            </v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-validacao-sdi"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="canRunItem(item)"
                @click="executarItem(item.id)"
              >
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>
                    mdi-play
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="canDeleteItem(item)"
                @click="openDialogDelete(item.id, item.nome)"
              >
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>
                    mdi-file-find-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  Detalhes
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="downloadLogs(item.id)">
                <v-list-item-title>
                  <v-icon small>
                    mdi-file-download-outline
                  </v-icon>
                  Downlad Logs
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">
        <span style="word-break: break-word">Deletar Validação de SDI #{{ dialogDeleteData.id }}</span>
      </template>
      <template slot="body">
        Tem certeza que deseja deletar a Validação de SDI <strong>{{ dialogDeleteData.titulo }}</strong>?
      </template>
    </dialog-delete>
    <general-dialog-detalhes
      ref="dialogDetalhes"
      persistent
      title="Detalhes da Validação de SDI"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          hide-default-footer
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          :mobile-breakpoint="10"
        />
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
import ValidacoesSdiService from '@/services/ValidacoesSdiService';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

export default {

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete.vue'),
    GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes.vue'),
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue')
  },
  mixins: [powerupsActionsMixins],

  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    powerupService: ValidacoesSdiService,
    powerupEntityName: 'Validador SDI',
    search: '',
    headers: [
      {
        text: '#',
        value: 'id'
      },
      {
        text: 'Nome',
        value: 'nome'
      },
      {
        text: 'Usuário',
        value: 'usuario'
      },
      {
        text: 'Executado',
        value: 'data_processamento'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        sortable: false,
        text: 'Ações',
        value: 'actions',
        class: 'pl-4'
      }
    ],
    dialogDownloadOptions: false,
    dialogDownloadOptionsData: {}
  }),

  methods: {
    downloadLogs (id) {
      const empresa = this.$store.getters.getEmpresa;
      ValidacoesSdiService
        .downloadLogs({ id, empresa })
        .then(res => {
          this.$toast.success('Preparando seu arquivo de logs para download.', '', { position: 'topRight' });
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `logs-validacoes-sdi-${id}.log`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          console.log(error);
          this.$toast.error('Falha ao baixar arquivo resultado :: Arquivo não encontrado.', '', { position: 'topRight' });
        });
    },
    openDialogDelete (id, titulo) {
      this.dialogDeleteData = { id, titulo };
      this.dialogDelete = true;
    },

    openDialogDetalhes (validacao) {
      const parametros = JSON.parse(validacao.parametros);
      this.dialogDetalhesData = [{ parametro: 'NOME DA VALIDAÇÃO:', valor: validacao.nome }];

      for (var [key, value] of Object.entries(parametros)) {
        this.dialogDetalhesData.push({
          parametro: `ARQUIVO #${key}:`,
          valor: `NOME: ${value.arquivo_original} - VALIDAÇÃO: ${value.tabela}`
        });
      }

      this.dialogDetalhes = true;
    }
  }
};
</script>

<style>
.swithInterna label {
  font-size: 13px !important;
  margin-left: 0px !important;
}
</style>